// extracted by mini-css-extract-plugin
export var container = "_ek-0";
export var icon = "_ek-1";
export var text = "_ek-2";